import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { loginUrlFor, afterLoginPath } from "../helper/loginRedirect";

export const ProtectedRoutes = () => {
    const location = useLocation();
    // TODO: Use authentication token
    let isTrueSet = true
    let PC_USR_NAME = localStorage.getItem('PC_USR_NAME')
    let PC_USR_TOKEN = localStorage.getItem('PC_USR_TOKEN')
    if ((PC_USR_NAME && PC_USR_TOKEN) === "" || (PC_USR_NAME && PC_USR_TOKEN) === null) {
        isTrueSet = false
    }
    // Not signed in: the login page, then back to the page asked for (a record link, say) —
    // helper/loginRedirect.js. This used to send everyone to the public home page.
    return isTrueSet ? <Outlet /> : <Navigate to={loginUrlFor(location.pathname + location.search)} replace />;
};

export const PublicRoutes = () => {
    const location = useLocation();
    // TODO: Use authentication token
    let PC_USR_TOKEN = localStorage.getItem('PC_USR_TOKEN')
    // let USR_ROLE = localStorage.getItem('USR_ROLE');
    let PC_USR_NAME = localStorage.getItem('PC_USR_NAME')
    let isTrueSet = (PC_USR_TOKEN && PC_USR_NAME);

    // Signed in on the login page (incl. the moment a login succeeds): go where ?next= asks — a
    // record link — or the dashboard. Login.js navigates to the same place, so neither wins wrongly.
    let trgLink = isTrueSet ? afterLoginPath(location.search) : '/';
    // let trgLink = '/'
    return isTrueSet ? <Navigate to={trgLink} replace /> : <Outlet />;
};
